import { NatureEnum } from '@/modules/analysis/models/natureEnum';

export function getSizeUnitItemsByNature(nature: string): string[] {
  let units = ['N/A'];

  if (
    // concrete
    nature === NatureEnum[0].value ||
    // clay
    nature === NatureEnum[3].value ||
    // sand
    nature === NatureEnum[4].value ||
    // limestone
    nature === NatureEnum[5].value ||
    // coal
    nature === NatureEnum[6].value ||
    // beckGround
    nature === NatureEnum[7].value ||
    // bitumen
    nature === NatureEnum[8].value ||
    // plants
    nature === NatureEnum[9].value ||
    // humus
    nature === NatureEnum[10].value ||
    // vegetableSoil
    nature === NatureEnum[11].value ||
    // sediment
    nature === NatureEnum[12].value ||
    // dustyResidues
    nature === NatureEnum[13].value ||
    // scrapMetal
    nature === NatureEnum[16].value
  ) {
    units = ['g', 'kg'];
    // liquid
  } else if (nature === NatureEnum[1].value) {
    units = ['ml', 'cc', 'L'];
    // tissue and paperSmear
  } else if (nature === NatureEnum[2].value || nature === NatureEnum[15].value) {
    units = ['cm2'];
  } // gas
  else if (nature === NatureEnum[14].value) {
    units = ['m3'];
  }
  return units;
}
